  $(document).ready(function () {
        /***Testimonials Slider***/
        $(".owl-carousel.testi-wraper").owlCarousel({
            loop: true,
            margin: 10,
            autoplayTimeout: 8000,
            autoplay: true,
            items: 1,
        });
    });